import { render, staticRenderFns } from "./impacto_por_area.vue?vue&type=template&id=1d893aba&scoped=true"
import script from "./impacto_por_area.vue?vue&type=script&lang=js"
export * from "./impacto_por_area.vue?vue&type=script&lang=js"
import style0 from "./impacto_por_area.vue?vue&type=style&index=0&id=1d893aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d893aba",
  null
  
)

export default component.exports